import * as React from 'react';
import { Divider, Drawer } from '@mui/material';
import { Close, Home, Menu as MenuIcon } from '@mui/icons-material';
import { Button, IconButton } from 'components';
import { useNavigate } from 'react-router';
import { CATEGORIES_MENU_CONFIG } from 'constants/categoriesMenu';
import { APP_ROUTES } from 'constants/routes';
import './MobileCategoriesDrawer.styled.scss';
import { NativeAccordion } from 'components/atoms/NativeAccordion/NativeAccordion';
import { NativeAccordionSelectable } from 'components/atoms/NativeAccordion/NativeAccordionSelectable';
import { useModals } from 'hooks/useModals';
import { MODALS } from 'store/contexts/ModalContext/modals';
import { useAppDispatch, useAppSelector } from 'store/store';
import { logoutUserAsyncThunk } from 'store/users/users.action';

export const MobileCategoriesDrawer = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { data: currentUser } = useAppSelector(
    (state) => state.users.currentUser
  );
  const { openModal } = useModals();
  const [isOpen, setIsOpen] = React.useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);
  const handleHomeClick = () => {
    navigate(APP_ROUTES.HOME);
    handleClose();
  };
  const handleSignInClick = () => {
    openModal(MODALS.LOGIN);
    handleClose();
  };
  const handleSignUpClick = () => {
    openModal(MODALS.REGISTRATION);
    handleClose();
  };
  const handleLogout = () => {
    dispatch(
      logoutUserAsyncThunk({
        onSuccess: () => {
          navigate(APP_ROUTES.HOME);
          handleClose();
        },
      })
    );
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        className="mobile-categories-drawer__trigger"
        color="primary"
        aria-label="open categories menu"
      >
        <MenuIcon fontSize="medium" />
      </IconButton>

      <Drawer
        anchor="left"
        open={isOpen}
        onClose={handleClose}
        className="mobile-categories-drawer"
        PaperProps={{
          className: 'mobile-categories-drawer__paper',
        }}
      >
        <div className="mobile-categories-drawer__content">
          <div className="mobile-categories-drawer__header">
            <div className="mobile-categories-drawer__title-wrap">
              <h6>CustomGifts</h6>
            </div>
            <IconButton
              onClick={handleClose}
              className="mobile-categories-drawer__close-button"
              aria-label="close categories"
            >
              <Close />
            </IconButton>
          </div>

          <div className="mobile-categories-drawer__body">
            <div className="mobile-categories-drawer__body-scroll">
              {!currentUser ? (
                <div className="mobile-categories-drawer__auth">
                  <Button
                    color="primary"
                    variant="contained"
                    className="mobile-categories-drawer__auth__button"
                    onClick={handleSignInClick}
                  >
                    Sign In
                  </Button>
                  <Button
                    color="primary"
                    variant="outlined"
                    className="mobile-categories-drawer__auth__button"
                    onClick={handleSignUpClick}
                  >
                    Sign Up
                  </Button>
                </div>
              ) : null}
              {!currentUser ? <Divider /> : null}
              <div
                className="mobile-categories-drawer__body__accordionlike-button"
                role="button"
                onClick={handleHomeClick}
              >
                <Home sx={{ color: 'secondary.light' }} />
                <h6>Home</h6>
              </div>
              <Divider />
              {CATEGORIES_MENU_CONFIG.map((category) => (
                <NativeAccordion
                  key={category.id}
                  title={category.displayName}
                  titleIcon={category.icon as React.ReactNode}
                >
                  <NativeAccordionSelectable
                    title={`View all ${category.displayName.toLowerCase()}`}
                    onClick={() => {
                      navigate(`/${category.id}`);
                      handleClose();
                    }}
                  />
                  {category.subCategories.map((subCategory) => (
                    <NativeAccordionSelectable
                      key={subCategory.id}
                      title={subCategory.displayName}
                      onClick={() => {
                        navigate(`/${category.id}/${subCategory.id}`);
                        handleClose();
                      }}
                    />
                  ))}
                </NativeAccordion>
              ))}
              <Divider />
              <div className="mobile-categories-drawer__body__accordionlike-button">
                <h6>About</h6>
              </div>
              <Divider />
              <div className="mobile-categories-drawer__body__accordionlike-button">
                <h6>Contact</h6>
              </div>
              <Divider />
              <div className="mobile-categories-drawer__body__accordionlike-button">
                <h6>Privacy Policy</h6>
              </div>
              <Divider />
              <div className="mobile-categories-drawer__body__accordionlike-button">
                <h6>Terms of Service</h6>
              </div>
            </div>
            {currentUser ? (
              <div className="mobile-categories-drawer__logout">
                <Button
                  color="primary"
                  variant="contained"
                  className="mobile-categories-drawer__auth__button"
                  onClick={handleLogout}
                  fullWidth
                >
                  Logout
                </Button>
              </div>
            ) : null}
          </div>
          <div className="mobile-categories-drawer__footer">
            <p className="caption">
              🚚 Free shipping on orders over $50 © 2026 GiftShop.
            </p>
            <p className="caption">All rights reserved.</p>
          </div>
        </div>
      </Drawer>
    </>
  );
};
